import "./Methodology.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import The3StepPatientJourney from "./sections/The3StepPatientJourney";
import PayrollInquiries from "./sections/PayrollInquiries";
import InformativeFooter from "@/reusable_sections/Footer";
export default function MethodologyPage() {
  return <div>
      <FraternalExcellenceHeader />
      <The3StepPatientJourney />
      <PayrollInquiries />
      <InformativeFooter />
    </div>;
}